import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getCentroAlumno() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}centro_alumno`);
    return response

  } catch (error) {
    console.error('Error al obtener el centro del alumno', error);
  }
}